import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { getWebHookSenderLogAsync, checkedState, unCheckedState,setSortConfig,getHeadingAsync,getAccountWebHookSenderLogAsync, checkedAllState,updatePagination,
    updateSearchPagination, unCheckedAllState,getWebhookRetryAsync } from './WebHookSenderLogSlice';
import WebHookSenderLogItem from "./WebHookSenderLogItem";
import { ViewDetails } from "./ViewDetails";
import WebHookSenderLogOffCanvas from "./WebHookSenderLogOffCanvas";
import OffCanvas from '../../../common/OffCanvas';
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import CustomPagination from "../../../common/Pagination";
import Select, { StylesConfig } from 'react-select';
import moment from "moment";
import { useDebounce } from "../../../_metronic/helpers";
import Loader from "../../../common/Loader";
import PageSizeSelect from "../../../common/PageSizeSelect";
import { getValueFromResource } from "../../../common/timeLiveFunction";
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

const WebHookSenderLog = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const webhooksenderlogid = params.get('WebHookSenderLogId');
    const { t } = useTranslation();
    const options = [{ value: '10', label: '10' }, { value: '20', label: '20' }, { value: '30', label: '30' }, { value: '40', label: '40' }, { value: '50', label: '50' }];
    const offCanvasList = [
        {
            name: 
            // t('Filters'),
            getValueFromResource('Filters',dispatch, t),
            width: '500px',
            componentName: <WebHookSenderLogOffCanvas webhooksenderlogid={webhooksenderlogid} t={t} />
        },
        {
            name: 
            // t("Details"),
            getValueFromResource('Details',dispatch, t),
            width: "500px",
            componentName: <ViewDetails t={t} />
        }
    ];
    const { WebHookSenderLogList,WebHookSenderLogCheckedIds, isReload,sortColumn,sortOrder,pageNo, pageSize, startRec, totalItems, recordsFiltered,sortIndex,sortDirection
        ,optionStatusValue,optionWebHookEventTypeValue,startDate,endDate,WebHookName, TargetURL,search,isSearch
    } = useAppSelector((state) => state.webHookSenderLog);
    const [showOffCanvas, setShowOffCanvas] = useState(false);
    const [selectedOffCanvas, setSelectedOffCanvas] = useState(offCanvasList[0]); // Store the selected OffCanvas object
    const { isLoading } = useAppSelector((state) => state.webHookSenderLog);
    
    const handleOnClickEvent = () => {
        const commaSeparatedString = WebHookSenderLogCheckedIds.join(', ');
        dispatch(getWebhookRetryAsync(commaSeparatedString));
    };

    const handleFilterOnClickEvent = (selectedObject:any) => {
        setSelectedOffCanvas(selectedObject);
        setShowOffCanvas(true);
    }

    const isGuid = (stringToTest: any) => {
        if (stringToTest[0] === "{") {
            stringToTest = stringToTest.substring(1, stringToTest.length - 1);
        }
        var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
        var x = regexGuid.test(stringToTest);
        return x;
    };

    useEffect(() => {
     
        dispatch(getAccountWebHookSenderLogAsync());
        // startRec == 0 && dispatch(getAccountWebHookAsync())
        // setTab('TimeOffList');
    },[pageNo, pageSize, sortOrder, sortColumn]);

    useEffect(() => {     
        dispatch(getAccountWebHookSenderLogAsync());
    }, [dispatch]);

    // const handlePageSizeChange = (event: any) => {
    //     const { value } = event;
    //     dispatch(setPageSize(Number(value)));
    //     if (webhooksenderlogid !== null) {
    //         if (isGuid(webhooksenderlogid)) {
    //             dispatch(getHeadingAsync(webhooksenderlogid));
    //             let SearchParamsValues = `${optionStatusValue},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionWebHookEventTypeValue}`;
    //             dispatch(getAccountWebHookSenderLogAsync({ currentPage: 1, pageSize: value, start: 0, order: sortIndex, orderDir: sortDirection, AccountWebhookSenderLogId: webhooksenderlogid, SearchParamsValues: SearchParamsValues, search: " " }));
    //         }
    //     }
    // };

    // const handlePageChange = (pageNumber: any) => {
    //     if (webhooksenderlogid !== null) {
    //         if (isGuid(webhooksenderlogid)) {
    //             dispatch(getHeadingAsync(webhooksenderlogid));
    //             const start = (pageNumber - 1) * pageSize;
    //             let SearchParamsValues = `${optionStatusValue},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionWebHookEventTypeValue}`;
    //             dispatch(getAccountWebHookSenderLogAsync({ currentPage: pageNumber, pageSize: pageSize, start: start, order: sortIndex, orderDir: sortDirection, AccountWebhookSenderLogId: webhooksenderlogid, SearchParamsValues: SearchParamsValues, search: search }));
    //         }
    //     }
    // };
    const onHandleSearch = (event: any) => {
        dispatch(updateSearchPagination(event.target.value));
    }

    const onHandlePageChange = (pageNumber: any) => {
        let objects = {
            "startRec": (pageNumber - 1) * Number(pageSize),
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    }

    const onHandlePageSizeChange = (selectedOption: any) => {
        let objects = {
            "startRec": 0,
            "pageSize": selectedOption.value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    }

    const debouncedSearchTerm = useDebounce(search, 500);

    useEffect(() => {
        if (isSearch && debouncedSearchTerm !== ' ') {
            if (webhooksenderlogid !== null) {
                if (isGuid(webhooksenderlogid)) {
                    dispatch(getHeadingAsync(webhooksenderlogid));
                    let SearchParamsValues = `${optionStatusValue},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionWebHookEventTypeValue}`;
                    dispatch(getAccountWebHookSenderLogAsync());
                }
            }
        }

    }, [debouncedSearchTerm]);


    // const handleSearch = (event: any) => {
    //     const { value } = event.target;
    //     dispatch(setSearchValue(value));
    // };

    // }
    return (
        <>
        {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold mainHeading">
                        {/* {t('WebHook Sender Log')} */}
                        {getValueFromResource('WebHook Sender Log',dispatch, t)}

                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="d-flex flex-column">
                            <div className="d-flex align-items-center flex-wrap">
                                <div className="me-1">
                                    <label className="fs-7 fs-7 fw-normal fw-semibold">
                                        {/* {t('WebHook Name')}: */}
                                        {getValueFromResource('WebHook Name',dispatch, t)}:

                                        </label>
                                </div>
                                <div>
                                    <span className="d-block">{WebHookName}</span>
                                </div>
                            </div>
                            <div className="d-flex align-items-center flex-wrap">
                                <div className="me-1">
                                    <label className="fs-7 fs-7 fw-normal fw-semibold">
                                        {/* {t('Target URL')}: */}
                                        {getValueFromResource('Target URL',dispatch, t)}:

                                        </label>
                                </div>
                                <div>
                                    <span className="d-block">{TargetURL}</span>
                                </div>
                            </div>
                        </div>

                        {/* <div className="d-flex align-items-center flex-wrap">
                            <label className="fs-7 fs-7 fw-normal fw-semibold me-1">{t('WebHook Name')} : </label>
                            <div>
                                <span className='d-block'>{WebHookName}</span>
                            </div>
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <label className="fs-7 fs-7 fw-normal fw-semibold me-1">{t('Target URL')} : </label>
                            <div>
                                <span className='d-block'>{TargetURL}</span>
                            </div>
                        </div> */}
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={(e: any) => onHandleSearch(e)}
                                placeholder={getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"

                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                styles={colourStyles}
                                options={options}
                                value={options.find(option => parseInt(option.value) == pageSize)}
                                onChange={handlePageSizeChange}
                                className='fs-7 fw-normal'

                            /> */}
                            <PageSizeSelect onChange={onHandlePageSizeChange} />

                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(WebHookSenderLogList.length > 0) ? (
                                <CustomPagination
                                currentPage={pageNo}                                  
                                  onPageChange={onHandlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    startRec={startRec}
                                    t={t}
                                    recordsFiltered={recordsFiltered}
                                >

                                </CustomPagination>
                            ) : null}
                        </div>

                        {(WebHookSenderLogList.length > 0 && pageSize < totalItems) &&
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        }

                        <button type="button" className="btn btn-sm btn-danger"
                            disabled={WebHookSenderLogCheckedIds.length === 0 ? true : false}
                            onClick={handleOnClickEvent}>
                            {/* {t('Retry Selected')} */}
                            {getValueFromResource('Retry Selected',dispatch, t)}
                        </button>
                        <>
                            &nbsp;
                            <button
                                id="kt_OffCanvas"
                                type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={() => handleFilterOnClickEvent(offCanvasList[0])}
                            >
                                {/* {t('Filters')} */}
                                {getValueFromResource('Filters',dispatch, t)}

                            </button>
                        </>
                    </div>
                </div>

                {/* <div className="card-body"> */}
                <div className="card-Report-body"> 

                    <div className="table-responsive">
                        <WebHookSenderLogItem webhooksenderlogid={webhooksenderlogid}
                            onhandleFilterOnClickEvent={handleFilterOnClickEvent}
                            offCanvasObject={offCanvasList[1]}
                            t={t}
                        />
                    </div>
                </div>
            </div>
            <OffCanvas
                isOpen={showOffCanvas}
                onClose={() => setShowOffCanvas(false)}
                obj={selectedOffCanvas}
            />
        </>
    )
}

export default WebHookSenderLog;





